module.exports = __webpack_public_path__ + "img/gp.17dfa510.png";